module.exports = __webpack_public_path__ + "static/header-text-f93cd93eeb41528b7f659f6ce8ca810f.png";